const config = {
    airtable: {
        token: process.env.REACT_APP_AIRTABLE_TOKEN,
    },
}

export { config };